export default __webpack_public_path__ + "static/iosChatbot4-c1cc61a478926d359203a85f088f3d84.png";